import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Box, Button, DialogContentText, Stack, TableCell, Typography } from '@mui/material';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import AddIcon from '@mui/icons-material/Add';
import { CustomFilterV2, DialogDefaultV2, TableWidgetV2 } from '../../../components/v2';
import * as selectorsDrones from '../../../store/drone/reducer';
import * as actionsDrones from '../../../store/drone/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as Roles from '../../../constants/role';
import Formulario from './Formulario';

const DronesV2 = ({ drones, loadDrones, deleteDrone, exportDrone, authData }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [localFilter, setLocalFilter] = useState({});
  const [openFilter, setOpenFilter] = useState(false);
  const [openExport, setOpenExport] = useState(false);

  const isAdmin = authData && (authData.role === Roles.ADMIN || authData.role === Roles.SUPER_ADMIN);

  useEffect(() => {
    loadDrones(localFilter);
  }, [loadDrones]);

  const onEdit = (rowId) => { setId(rowId); setOpen(true); };
  const onAdd = () => { setId(null); setOpen(true); };
  const onClose = (isSave) => {
    if (isSave) loadDrones(localFilter);
    setOpen(false);
    setId(null);
  };

  const renderRows = (r) => (
    <>
      <TableCell>{r.modelo}</TableCell>
      <TableCell>{r.numSerieDrone}</TableCell>
      <TableCell>{r.numSerieRadio}</TableCell>
      <TableCell>{r.codigoSisant}</TableCell>
      <TableCell>{r.codigoAnatel}</TableCell>
      <TableCell>{r.inspetorName}</TableCell>
    </>
  );

  return (
    <Box sx={{ p: 3 }}>
      <Stack spacing={3}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={2}
          sx={{ pr: 2 }}
        >
          <Typography variant="h4">Drones</Typography>
          <Stack direction="row" spacing={1}>
            <Button variant="outlined" startIcon={<FilterListOutlinedIcon />} onClick={() => setOpenFilter(true)}>
              Filtros
            </Button>
            {isAdmin && (
              <>
                <Button variant="outlined" onClick={() => setOpenExport(true)}>
                  Exportar
                </Button>
                <Button variant="contained" startIcon={<AddIcon />} onClick={onAdd}>
                  Novo
                </Button>
              </>
            )}
          </Stack>
        </Stack>

        <TableWidgetV2
          rows={drones || []}
          titles={['Modelo', 'Série do drone', 'Série do rádio', 'Código SISANT', 'Código ANATEL', 'Inspetor']}
          headerTitle="Drones"
          deleteMessage="A informação será removida e não poderá ser mais recuperada."
          renderRows={renderRows}
          hasRowActions={isAdmin}
          onEdit={onEdit}
          onView={onEdit}
          onDelete={(rowId) => deleteDrone(rowId)}
          showEdit={isAdmin}
          showView={!isAdmin}
          showDelete={isAdmin}
          hasAdd={false}
        />

        <CustomFilterV2
          variant="dialog"
          open={openFilter}
          onClose={() => setOpenFilter(false)}
          title="Filtros"
          fullWidth
          appliedFilter={localFilter}
          fields={[
            { field: 'useCodigo', codigoLabel: 'Modelo', md: 3, xs: 12 },
            { field: 'useFilterInput', filterKey: 'numSerieDrone', label: 'Série do drone', md: 3, xs: 12 },
            { field: 'useUsuarios', label: 'Inspetor', key: 'usuarioId', grupos: [Roles.ADMIN, Roles.INSPETOR], ativo: true, md: 4, xs: 12 },
          ]}
          onFilter={(filterData) => {
            setLocalFilter(filterData);
            loadDrones(filterData);
            setOpenFilter(false);
          }}
        />
      </Stack>

      <Formulario id={id} open={open} onClose={onClose} />

      <DialogDefaultV2
        open={openExport}
        handlerCancel={() => setOpenExport(false)}
        handlerConfirm={() => exportDrone(localFilter, () => setOpenExport(false))}
        title="Confirmação"
        confirmMessage="Sim"
        cancelMessage="Não"
      >
        <DialogContentText>Deseja baixar todas as informações filtradas?</DialogContentText>
      </DialogDefaultV2>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  drones: selectorsDrones.getDrones(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ ...actionsDrones }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DronesV2));
